import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Slider from "react-slider";
import "./App.css";
import { useMapEvents } from "react-leaflet";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";





// Эти два блока вынеси вверх файла, вместе с другими константами
const defaultAdvantageSteps = [
  [5, 0.2],
  [10, 0.4],
  [15, 0.6],
  [100, 0.85]
];

const advantageStepsPresident2018 = [
  [40, 0.2],
  [50, 0.4],
  [60, 0.6],
  [100, 0.85]
];


const president2018Colors = {
  Путин: "#0072bc",           // Синий
  Грудинин: "#a50026",         // Тёмно-красный (КПРФ)
  Жириновский: "#00bfff",      // Голубой
  Собчак: "#00ff00",           // Кислотно-зелёный
  Сурайкин: "#d73027",         // Ярко-красный
  Титов: "#70a9d8",            // Светло-серо-голубой
  Явлинский: "#8bc34a"         // Светло-зелёный
};
const detailMap = {
  true: 'uik',         // когда mapZoom > 12
  false: 'district'    // иначе
};

function ZoomWatcher({ onZoomChange }) {
  useMapEvents({
    zoomend: (e) => {
      const newZoom = e.target.getZoom();
      onZoomChange(newZoom);
    },
  });
  return null;
}
function getWinnersFromGeoJSON(features, prefix = "2013_mer_") {
  const winners = new Set();

  for (const feature of features) {
    const props = feature.properties;
    const scores = {};

    for (const key in props) {
      if (key.startsWith(prefix)) {
        const rawName = key.replace(prefix, "");
		const name = rawName.split("_")[0]; // Берем только фамилию

        if (!/^[А-ЯЁ]/.test(name)) continue;  // добавляем фильтр по заглавной букве
        scores[name] = props[key];
      }
    }

    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    if (sorted.length > 0) {
      const winner = sorted[0][0];
      winners.add(winner);
    }
  }

  return Array.from(winners);
}


function getAdvantageLevels(features, prefix) {
  const levels = {};

  for (const feature of features) {
    const props = feature.properties;
    const scores = {};

    for (const key in props) {
      if (key.startsWith(prefix)) {
        const rawName = key.replace(prefix, "");
		const name = rawName.split("_")[0]; // Берем только фамилию

        if (!/^[А-ЯЁ]/.test(name)) continue;
        scores[name] = props[key];
      }
    }

    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    if (sorted.length < 2) continue;

    const winner = sorted[0][0];
    const advantage = sorted[0][1] - sorted[1][1];

    let level = 1;
    if (advantage >= 20) level = 4;
    else if (advantage >= 10) level = 3;
    else if (advantage >= 5) level = 2;

    if (!levels[winner] || levels[winner] < level) {
      levels[winner] = level;
    }
  }

  return levels;
}


const presidentTurnoutThresholds = [
  { limit: 50, color: "#e6f4ea" },  // до 50%
  { limit: 60, color: "#a6d9b7" },  // 50-60%
  { limit: 65, color: "#5bbf83" },  // 60-65%
  { limit: 70, color: "#3a9d66" },  // 65-70%
  { limit: 101, color: "#21814f" }, // более 70%
];

const duma2016Colors = {
  "Единая Россия":       "#0072bc",
  "КПРФ":                "#d73027",
  "ЛДПР":                "#00bfff",
  "Справедливая Россия": "#f28c28",
  "Яблоко":              "#8bc34a",
};

const duma2021Colors = {
  "Единая Россия":       "#0072bc",
  "КПРФ":                "#d73027",
  "ЛДПР":                "#00bfff",
  "СРЗП":                "#f28c28",
  "Новые люди":          "#50bdc4",
  "Яблоко":              "#8bc34a"
};

const baseColors = {
  Собянин: "#0072bc",    // синий
  Навальный: "#f28c28",  // оранжевый
  Мельников: "#d73027",  // красный
  Митрохин: "#8bc34a",   // светло-зелёный (как Явлинский)
  Дегтярёв: "#00bfff",
  Дегтярев: "#00bfff",   // голубой (как Жириновский)
  Левичев: "#999999" ,    // серый
  Кумин: "#d73027",
  Свиридов: "#4caf50",
  Балакин: "#ff9800",

  'ЕдинаяРоссия':'#0055A4',  // синий ЕР
  'КПРФ':                 '#D11D22',  // красный КПРФ
  'ЛДПР':                 '#FFCC00',  // жёлтый ЛДПР
  'Справедливая Россия':  '#E31E1C',  // тёмно-красный СР
  'Новые Люди':           '#00BFFF',  // небесно-голубой
};


function shadeColor(hex, alpha) {
  if (!hex) return "#cccccc"; // Защита от undefined

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}


const turnoutThresholds = [
  { limit: 20, color: "#e6f4ea" },
  { limit: 35, color: "#a6d9b7" },
  { limit: 50, color: "#5bbf83" },
  { limit: 65, color: "#3a9d66" },
  { limit: 101, color: "#21814f" }
];

const presidentColors = {
  Путин: "#0072bc",         // как у Собянина — синий
  Зюганов: "#d73027",       // ярко-красный
  Прохоров: "#00ff00",      // кислотно-зелёный
  Жириновский: "#00bfff",   // голубой
  Миронов: "#ffcc00"        // желто-оранжевый
};


const invalidThresholds = [
  { limit: 0.5, color: "#fde8ef" },
  { limit: 1, color: "#fcd2e1" },
  { limit: 1.5, color: "#f7b6cf" },
  { limit: 2, color: "#ef6cae" },
  { limit: 100, color: "#c51b8a" }
];

const electionPrefixes = {
  "Президент": {
    2012: "2012_president_",
    2018: "2018_president_"
  },
  "Мэр": {
    2013: "2013_mer_",
    2018: "2018_mer_"
  },
  "Госдума": {
    2016: "2016_duma_",
    2021: "2021_duma_"
  },
  "Мосгордума": {
    2014: "2014_mosgorduma_",
    2019: "2019_mosgorduma_"
  },
  "Муниципальные": {
    2017: "2017_mun_"
  }
};

function getStyleByDataType(props, dataType, year, activeElectionLevel) {
  const mode = electionPrefixes[activeElectionLevel]?.[year] || "";
  const threshold = activeElectionLevel === "Президент"
  ? presidentTurnoutThresholds
  : turnoutThresholds;
  if (dataType === "Явка") {
    const value = props[`${mode}явка`] || 0;
    const threshold = activeElectionLevel === "Президент"
      ? presidentTurnoutThresholds
      : turnoutThresholds;
    const color = threshold.find(t => value < t.limit)?.color || "#ccc";

    return {
      color: "#000",
      weight: 1,
      fillOpacity: 0.8,
      fillColor: color,
    };
  }

	if (dataType === "Процент испорченных бюллетеней") {
	  const invalidFieldVariants = [
		`${mode}недействительны`,
		`${mode}недействительных`,
		`${mode}недействительные`
	  ];

	
	const invalidField = invalidFieldVariants.find(f => f in props);
	const value = invalidField ? props[invalidField] : 0;
	const fillColor = invalidThresholds.find(t => value < t.limit)?.color || "#ccc";

    return {
      color: "#000",        // граница УИКов/районов — чёрная
      weight: 1,
      fillOpacity: 0.8,
      fillColor: fillColor, // заливка по проценту испорченных бюллетеней
    };
}}

function getWinnerColorByAdvantage(props, year, activeElectionLevel) {
  let candidates = {};
  let colorPalette = {};

  // --- Выбираем кандидатов и палитру ---
  if (activeElectionLevel === "Президент") {
    if (year === 2012) {
      if (props.uik_num) {
        // УИКи: фамилии через парсинг
        for (const key in props) {
          if (key.startsWith("2012_president_")) {
            const rawName = key.replace("2012_president_", "");
            const shortName = rawName.split("_")[0];
            if (/^[А-ЯЁ]/.test(shortName)) {
              candidates[shortName] = props[key];
            }
          }
        }
      } else {
        // Районы: короткие имена
        candidates = {
          Путин: props[`2012_president_Путин`] || 0,
          Зюганов: props[`2012_president_Зюганов`] || 0,
          Прохоров: props[`2012_president_Прохоров`] || 0,
          Жириновский: props[`2012_president_Жириновский`] || 0,
          Миронов: props[`2012_president_Миронов`] || 0,
        };
      }
      colorPalette = presidentColors;
    } 
    else if (year === 2018) {
      if (props.uik_num) {
            for (const key in props) {
              if (key.startsWith("2018_president_")) {
                const rawName   = key.replace("2018_president_", "");
                const shortName = rawName.split("_")[0];
                // Отсекаем "явка", "недействительные" и все прочие не-кандидаты
                if (/^[А-ЯЁ]/.test(shortName)) {
                  candidates[shortName] = props[key];
                }
              }
            }
          } else {
        candidates = {
          Путин: props[`2018_president_Путин`] || 0,
          Грудинин: props[`2018_president_Грудинин`] || 0,
          Жириновский: props[`2018_president_Жириновский`] || 0,
          Собчак: props[`2018_president_Собчак`] || 0,
          Сурайкин: props[`2018_president_Сурайкин`] || 0,
          Титов: props[`2018_president_Титов`] || 0,
          Явлинский: props[`2018_president_Явлинский`] || 0,
        };
      }
      colorPalette = president2018Colors;
    }
  }
  else if (activeElectionLevel === "Госдума" && year === 2016) {
    // Госдума 2016 (список)
    const prefix = electionPrefixes["Госдума"]?.[2016] || "";

    // Берём только те партии, для которых задан цвет
    for (const key in props) {
      if (!key.startsWith(prefix)) continue;

      const rawName = key.slice(prefix.length);        // например "Единая Россия"
      if (!(rawName in duma2016Colors)) continue;      // фильтруем по вашей палитре

      candidates[rawName] = props[key];
    }

    colorPalette = duma2016Colors;
  }

   else if (activeElectionLevel === "Госдума" && year === 2021) {
    const prefix = electionPrefixes["Госдума"][2021] || "";
    // только те партии, что в палитре
    for (const key in props) {
      if (!key.startsWith(prefix)) continue;
      const name = key.slice(prefix.length);
      if (name in duma2021Colors) {
        candidates[name] = props[key] || 0;
      }
    }
    colorPalette = duma2021Colors;
  }

  else if (activeElectionLevel === "Мэр") {
    const prefix = electionPrefixes["Мэр"]?.[year] || "";

    for (const key in props) {
      if (!key.startsWith(prefix)) continue;

      const rawName = key.slice(prefix.length);           // например "Собянин"
      const shortName = rawName.split("_")[0];            // на случай "Собянин_явка"
      if (/^[А-ЯЁ]/.test(shortName)) {
        candidates[shortName] = props[key];
      }
    }

    colorPalette = baseColors;
  }


  // --- Определяем победителя ---
  const sorted = Object.entries(candidates).sort((a, b) => b[1] - a[1]);
  if (sorted.length === 0) {
    return "rgba(204,204,204,0.3)";
  }
  const winner    = sorted[0][0];
  const advantage = sorted[0][1] - (sorted[1]?.[1] ?? 0);
  const baseColor = colorPalette[winner] || "#cccccc";

  // --- Шаги прозрачности (как у вас было) ---
  const steps = (activeElectionLevel === "Президент" && year === 2018)
    ? advantageStepsPresident2018
    : defaultAdvantageSteps;
  const alpha = steps.find(([limit]) => advantage < limit)?.[1] || 1;

  // Возвращаем итоговый цвет
  return shadeColor(baseColor, alpha);
}






function App() {
  const [year, setYear] = useState(2012);
  const [geoData, setGeoData] = useState(null);
  const [activeDataType, setActiveDataType] = useState("Победитель");
  const [activeElectionLevel, setActiveElectionLevel] = useState("Президент");
  const [mapZoom, setMapZoom] = useState(10);
  const availablePrecinctElections = {
    'Президент':   [2012, 2018],
    'Госдума':     [2016, 2021],          // если для Госдумы уИКов нет, оставьте пустым
    'Мосгордума':  [2014, 2019],          // аналогично
    'Мэр':         [2013, 2018]           // и т.д.
  };

const showPrecinctLayer =
  mapZoom > 12 &&
  availablePrecinctElections[activeElectionLevel]?.includes(year);

const [districtData, setDistrictData] = useState(null);
const [uikData, setUikData] = useState(null);
const [legendLevels, setLegendLevels] = useState({});
const [districtLegendLevels, setDistrictLegendLevels] = useState({});
const mapRef = useRef();
const [selectedFeature, setSelectedFeature] = useState(null);

useEffect(() => {
  // Очистим данные перед новой загрузкой
  setUikData(null);
  setDistrictData(null);

  const detailMap = {
    true: 'uik',
    false: 'district'
  };
  const levelMap = {
    Президент: 'president',
    Мэр: 'mer',
    Госдума: 'gd',
    Мосгордума: 'mgd'
  };

  const isPrecinct = mapZoom > 12;
  const detail = detailMap[isPrecinct];
  const level = levelMap[activeElectionLevel];
  if (!detail || !level) return;

  const fileName = `${detail}_${level}_${year}.geojson`;
  fetch(`${process.env.PUBLIC_URL}/data/${fileName}`)
    .then(res => {
      if (!res.ok) throw new Error(`Ошибка загрузки ${fileName}: ${res.statusText}`);
      return res.json();
    })
    .then(data => {
      const prefix = electionPrefixes[activeElectionLevel]?.[year] || '';
      if (detail === 'uik') {
        setUikData(data);
        setLegendLevels(getAdvantageLevels(data.features, prefix));
      } else {
        setDistrictData(data);
        setDistrictLegendLevels(getAdvantageLevels(data.features, prefix));
      }
    })
    .catch(err => console.error(err));
}, [year, activeElectionLevel, mapZoom]);



const showDistrictLayer =
  mapZoom <= 12 && (
    (activeElectionLevel === 'Президент'  && [2012,2018].includes(year))    ||
    (activeElectionLevel === 'Мэр'        && [2013,2018].includes(year))    ||
    (activeElectionLevel === 'Госдума'    && [2016,2021].includes(year)) ||  
    (activeElectionLevel === 'Мосгордума' && [2014,2019].includes(year))
  );
console.log("Show Precinct Layer:", showPrecinctLayer);
console.log("Show District Layer:", showDistrictLayer);
console.log("uikData loaded:", uikData?.features?.length || 0);
  const availableYearsByLevel = {
    Президент: [2012, 2018],
    Госдума: [2016, 2021],
    Мэр: [2013, 2018]
  };

  const availableYears = availableYearsByLevel[activeElectionLevel] || [2012];
  useEffect(() => {
    if (!availableYears.includes(year)) {
      setYear(availableYears[0]); // или Math.max(...availableYears)
    }
  }, [activeElectionLevel]);

  const stepByElection = {
    Президент: 6,
    Госдума: 5,
    Мэр: 5
  };
  const sliderStep = stepByElection[activeElectionLevel] || 1;


  const electionMeta = [
  { level: "Президент", short: "През.", years: [2012, 2018] },
  { level: "Госдума", short: "ГД", years: [2016, 2021] },
  { level: "Мэр", short: "Мэр", years: [2013, 2018] }
];



  // Кэш для подгрузки
  const dataCache = {};

  const fieldByDataType = {
  "Явка": ["явка"],
  "Процент испорченных бюллетеней": [
    "недействительны",
    "недействительных",
    "недействительные"
  ]
};
  const electionCodeByLevel = {
    "Президент": "president",
    "Госдума": "gd",
    "Мэр": "mer"
  };

  async function collectStatByDistrict(districtName, activeDataType) {
    const fieldVariants = activeDataType === "Явка"
      ? ["явка"]
      : ["недействительны", "недействительных", "недействительные"];

    const stat = [];

    for (const { level, short, years } of electionMeta) {
      const electionCode = electionCodeByLevel[level];
      for (const year of years) {
        const prefix = electionPrefixes[level]?.[year] || "";
        const url = `${process.env.PUBLIC_URL}/data/district_${electionCode}_${year}.geojson`;

        console.log("🔽 Загружаем:", url);

        let data;
        if (dataCache[url]) {
          data = dataCache[url];
          console.log("📦 [из cache] Кол-во features в", url, ":", data.features?.length);
        } else {
          try {
            const res = await fetch(url);
            if (!res.ok) {
              console.warn("❌ Ошибка загрузки (res not ok):", url, res.status);
              continue;
            }

            const contentType = res.headers.get("content-type");
            if (
              !contentType ||
              (!contentType.includes("application/json") && !contentType.includes("application/geo+json"))
            ) {
              console.warn("⚠️ Не JSON:", url, contentType);
              continue;
            }


            data = await res.json();
            dataCache[url] = data;

            console.log("📦 Кол-во features в", url, ":", data.features?.length);
          } catch (e) {
            console.warn("Ошибка загрузки:", url, e);
            continue;
          }
        }

        const cleanName = districtName.toLowerCase().replace("район", "").trim();
        console.log("🔍 Сравнение:");
        data.features.forEach((f) => {
          const a = f.properties?.name?.toLowerCase().replace("район", "").trim();
          const b = districtName.toLowerCase().replace("район", "").trim();
          console.log("→", `"${a}" === "${b}"`, a === b);
        });

        const match = data.features.find((f) => {
          const propName = f.properties?.name?.toLowerCase().replace("район", "").trim();
          return propName === cleanName;
        });

        console.log("🔍 Ищем район:", cleanName, "=> Найден:", !!match);

        if (!match) continue;
        console.log("🔍 Ищем район:", cleanName);
        console.log("🎯 Найден match:", match);
        if (match) {
          console.log("🧾 Ключи полей в match:", Object.keys(match.properties));
        }



        for (const suffix of fieldVariants) {
          const field = `${prefix}${suffix}`;
          const value = match.properties?.[field];
          console.log("👉 Пробуем поле:", field, "=>", value);
          if (value != null) {
            stat.push({ year, level, label: short, value: +value });
            break;
          }
        }
      }
    }

    console.log("📊 STAT (district):", districtName, activeDataType, stat);
    return stat;
  }


  async function collectStatByUik(uikNum, activeDataType) {
    const fieldVariants = fieldByDataType[activeDataType];
    const stat = [];

    for (const { level, short, years } of electionMeta) {
      const electionCode = electionCodeByLevel[level];
      for (const year of years) {
        const prefix = electionPrefixes[level]?.[year] || "";
        const url = `${process.env.PUBLIC_URL}/data/uik_${electionCode}_${year}.geojson`;

        console.log(`🟡 Загружаем: ${url}`);
        console.log("Ищем uik_num:", uikNum);
        console.log("Префикс:", prefix);

        let data;
        if (dataCache[url]) {
          data = dataCache[url];
        } else {
          try {
            const res = await fetch(url);
            if (!res.ok) continue;
            data = await res.json();
            console.log("🧩 Все районы в файле:", url);
            data.features.forEach(f => {
              console.log("-", f.properties?.name);
            });
            dataCache[url] = data;
          } catch (e) {
            console.warn("Ошибка загрузки:", e);
            continue;
          }
        }

        const match = data.features.find(
          (f) => f.properties?.uik_num === uikNum
        );

        console.log("🔍 Найденный feature:", match);

        if (!match) continue;

        for (const suffix of fieldVariants) {
          const field = `${prefix}${suffix}`;
          const value = match.properties?.[field];
          console.log("Пробуем поле:", field, "=>", value);
          if (value != null) {
            stat.push({ year, level, label: short, value: +value });
            console.log("✅ Найдено значение:", value);
            break;
          }
        }
      }
    }

    console.log("📦 Итоговая статистика:", stat);
    return stat;
  }





return (
  <div className="App">
    <div className="title-wrapper">
      <div className="title-decorated">
        <h1>Выборы Москвы</h1>
      </div>
    </div>

    {/* Слайдер */}
    <div className="slider-container">
      <label>Год: {year}</label>
    <Slider
      className="slider"
      value={year}
      min={Math.min(...availableYears)}
      max={Math.max(...availableYears)}
      step={sliderStep}
      onChange={(val) => {
        const nearest = availableYears.reduce((a, b) =>
          Math.abs(b - val) < Math.abs(a - val) ? b : a
        );
        setYear(nearest);
      }}
      renderTrack={(props) => <div {...props} className="slider-track" />}
      renderThumb={(props) => <div {...props} className="slider-thumb" />}
    />
    </div>

    {/* Карта + панели */}
    <div className="map-wrapper">
      <div className="map-container">
        {/* Верхняя панель */}
        <div className="top-controls">
          {["Явка", "Победитель", "Процент испорченных бюллетеней"].map((label) => (
            <button
              key={label}
              className={activeDataType === label ? "active" : ""}
              onClick={() => setActiveDataType(label)}
            >
              {label}
            </button>
          ))}
        </div>

        {/*
        {activeElectionLevel === "Госдума" && (
          <div className="center-controls">
            {["Округ", "Список"].map((label) => (
              <button
                key={label}
                className={activeListType === label ? "active" : ""}
                onClick={() => setActiveListType(label)}
              >
                {label}
              </button>
            ))}
          </div>
        )}
        */}


        {/* Боковая панель */}
        <div className="controls">
          {["Президент", "Госдума", "Мэр"].map((label) => (
            <button
              key={label}
              className={activeElectionLevel === label ? "active" : ""}
              onClick={() => setActiveElectionLevel(label)}
            >
              {label}
            </button>
          ))}
        </div>


        {/* Leaflet карта */}
        <MapContainer
          center={[55.7558, 37.6173]}
          zoom={10}
          className="map-container"
          whenCreated={(map) => {
            mapRef.current = map;
            map.on("zoomend", () => {
              const zoom = map.getZoom();
              setMapZoom(zoom);
              console.log("Zoom now:", zoom);
            });
          }}
        >


      {selectedFeature && (
        <div className="info-panel">
          <button className="close-btn" onClick={() => setSelectedFeature(null)}>×</button>

          <h4>
            {selectedFeature.properties.name ||
              (selectedFeature.properties.uik_num
                ? `УИК №${selectedFeature.properties.uik_num}`
                : "Участок")}
          </h4>

          {(activeDataType === "Явка" || activeDataType === "Процент испорченных бюллетеней") && selectedFeature.stats?.length > 0 ? (
            <>
              <div
                style={{
                  width: "clamp(280px, 95%, 500px)",  // ширина панели адаптивно, не на всю ширину
                  height: "clamp(160px, 20vh, 240px)",
                  marginTop: "1.2em",
                  marginRight: "auto",               // чтобы панель не прилипала к правому краю
                  marginLeft: "auto"                 // и по центру
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
               {(() => {
                const labelOffsets = {
                  "През.": 0,
                  "ГД": 0.25,
                  "Мэр": 0.5
                };

                const processedStats = selectedFeature.stats.map(d => ({
                  ...d,
                  yearOffset: d.year + (labelOffsets[d.label] || 0)
                }));

                return (
                  <BarChart
                    data={processedStats}
                    margin={{ top: 5, right: 16, bottom: 40, left: 20 }}
                  >
                    <XAxis
                      type="number"
                      dataKey="yearOffset"
                      domain={[2011, 2024]}
                      ticks={[2012, 2014, 2016, 2018, 2020, 2022]}
                      tickFormatter={(val) => {
                        const labels = {
                          2012: 2012,
                          2014: 2014,
                          2016: 2016,
                          2018: 2018,
                          2020: 2020,
                          2022: 2022
                        };
                        return labels[val] || "";
                      }}
                      scale="linear"
                    />

                    <YAxis
                      domain={
                        activeDataType === "Процент испорченных бюллетеней" ? [0, 5] : [0, 100]
                      }
                      tickFormatter={(val) => `${val}%`}
                    />

                    <Tooltip
                      formatter={(value, name, props) => [
                        `${value.toFixed(1)}%`,
                        props.payload.label
                      ]}
                      labelFormatter={(val) => {
                        return `${Math.floor(val)}`
                      }}
                    />

                    {["През.", "ГД", "Мэр"].map((label, i) => (
                      <Bar
                        minPointSize={0}
                        minbarSize = {12}
                        key={label}
                        dataKey={(entry) => entry.label === label ? entry.value : null}
                        name={label}
                        fill={["#4287f5", "#4caf50", "#ffc107"][i]}
                        barSize={24}
                        radius={[2, 2, 0, 0]}
                      />
                    ))}
                  </BarChart>
                );
              })()}



                </ResponsiveContainer>
              </div>
              {/* Мини-легенда */}
              <div style={{
                marginTop: "1rem",
                display: "flex",
                gap: "1.2rem",
                justifyContent: "center",
                fontSize: "clamp(1rem, 1vw, 1rem)",
                flexWrap: "wrap"
              }}>

                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <div style={{ width: 12, height: 12, backgroundColor: "#4287f5" }}></div>
                  <span>Президент</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <div style={{ width: 12, height: 12, backgroundColor: "#4caf50" }}></div>
                  <span>Госдума</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                  <div style={{ width: 12, height: 12, backgroundColor: "#ffc107" }}></div>
                  <span>Мэр</span>
                </div>
              </div>
            </>
          ) : activeDataType === "Победитель" ? (
            // 🟦 Старая панель Победитель
            (() => {
              const prefix = electionPrefixes[activeElectionLevel]?.[year] || "";
              let mainNames;
              let palette;

              if (activeElectionLevel === "Президент") {
                palette = year === 2012 ? presidentColors : president2018Colors;
                mainNames = Object.keys(palette);
              } else if (activeElectionLevel === "Госдума") {
                palette = year === 2016 ? duma2016Colors : duma2021Colors;
                mainNames = Object.keys(palette);
              } else {
                palette = baseColors;
                mainNames = Object.keys(baseColors);
              }

              const entries = Object.entries(selectedFeature.properties)
                .map(([key, value]) => ({
                  key,
                  name: key.replace(prefix, ""),
                  value
                }))
                .filter(({ key, name }) =>
                  key.startsWith(prefix) &&
                  /^[А-ЯЁ]/.test(name) &&
                  mainNames.includes(name)
                );

              return entries
                .sort((a, b) => (b.value ?? -1) - (a.value ?? -1))
                .map(({ name, value }) => {
                  const color = palette[name] || "#999";
                  return (
                    <div key={name} className="bar-row">
                      <div className="bar-label">{name}</div>
                      <div className="bar-wrapper">
                        {value != null ? (
                          <div
                            className="bar-fill"
                            style={{ width: `${value.toFixed(1)}%`, backgroundColor: color }}
                          />
                        ) : (
                          <div className="bar-no-data">Нет данных</div>
                        )}
                      </div>
                      <div className="bar-percent">
                        {value != null ? `${value.toFixed(1)}%` : ""}
                      </div>
                    </div>
                  );
                });
            })()
          ) : null}
        </div>
      )}









      {showDistrictLayer && !showPrecinctLayer && activeDataType === "Победитель" && (
        <div className="legend-box-horizontal">
          <h4>Преимущество победителя (%)</h4>
          <div className="legend-horizontal">
            {Object.entries(districtLegendLevels).map(([name, level]) => (
              <div className="legend-candidate" key={name}>
                {Array.from({ length: level }, (_, i) => {
                  const alpha = [0.2, 0.4, 0.6, 0.85][i];
                  const labels =
                    activeElectionLevel === "Президент" && year === 2018
                      ? ["менее 40", "40–50", "50–60", "более 60"]
                      : ["менее 5", "5–10", "10–20", "более 20"];

                  // теперь обрабатываем 3 ветки: Президент, Госдума-2016, Госдума-2021
                  let legendBaseColor;
                  if (activeElectionLevel === "Президент") {
                    legendBaseColor = year === 2018
                      ? president2018Colors[name]
                      : presidentColors[name];
                  } else if (activeElectionLevel === "Госдума" && year === 2016) {
                    legendBaseColor = duma2016Colors[name];
                  } else if (activeElectionLevel === "Госдума" && year === 2021) {
                    legendBaseColor = duma2021Colors[name];
                  } else {
                    legendBaseColor = baseColors[name];
                  }

                  return (
                    <div key={i} className="legend-entry">
                      <div
                        className="legend-color-box"
                        style={{ backgroundColor: shadeColor(legendBaseColor, alpha) }}
                      />
                      <div className="legend-label">{labels[i]}</div>
                    </div>
                  );
                })}
                <div className="legend-name">{name}</div>
              </div>
            ))}
          </div>
        </div>
      )}





      {showPrecinctLayer && activeDataType === "Победитель" && (
        <div className="legend-box-horizontal">
          <h4>Преимущество победителя (%)</h4>
          <div className="legend-horizontal">
            {Object.entries(legendLevels).map(([name, level]) => (
              <div className="legend-candidate" key={name}>
                {Array.from({ length: level }, (_, i) => {
                  const alpha = [0.2, 0.4, 0.6, 0.85][i];
                  const labels =
                    activeElectionLevel === "Президент" && year === 2018
                      ? ["менее 40", "40–50", "50–60", "более 60"]
                      : ["менее 5", "5–10", "10–20", "более 20"];

                  let legendBaseColor;
                  if (activeElectionLevel === "Президент") {
                    legendBaseColor = year === 2018
                      ? president2018Colors[name]
                      : presidentColors[name];
                  } else if (activeElectionLevel === "Госдума" && year === 2016) {
                    legendBaseColor = duma2016Colors[name];
                  } else if (activeElectionLevel === "Госдума" && year === 2021) {
                    legendBaseColor = duma2021Colors[name];
                  } else {
                    legendBaseColor = baseColors[name];
                  }

                  return (
                    <div key={i} className="legend-entry">
                      <div
                        className="legend-color-box"
                        style={{ backgroundColor: shadeColor(legendBaseColor, alpha) }}
                      />
                      <div className="legend-label">{labels[i]}</div>
                    </div>
                  );
                })}
                <div className="legend-name">{name}</div>
              </div>
            ))}
          </div>
        </div>
      )}







            <TileLayer
              attribution='Tiles &copy; Esri — Esri, DeLorme, NAVTEQ'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
            />
            <ZoomWatcher onZoomChange={setMapZoom} />


      {showDistrictLayer && districtData && !showPrecinctLayer && (
        <GeoJSON
          key={`district-${year}-${activeElectionLevel}-${activeDataType}-${districtData.features.length}`}
          data={districtData}
          style={(feature) => {
            if (activeDataType === "Победитель") {
              return {
                // чёрная граница, как прежде
                color: "#000",
                weight: 2,
                // полностью непрозрачная заливка
                fillOpacity: 1,
                // цвет победителя берётся из baseColors через getWinnerColorByAdvantage
                fillColor: getWinnerColorByAdvantage(
                  feature.properties,
                  year,
                  activeElectionLevel
                ),
              };
            }
            // для остальных типов данных используем уже готовую функцию
            return getStyleByDataType(
              feature.properties,
              activeDataType,
              year,
              activeElectionLevel
            );
          }}
          onEachFeature={(feature, layer) => {
            layer.on("click", async () => {
              setSelectedFeature(null);

              if (activeDataType === "Явка" || activeDataType === "Процент испорченных бюллетеней") {
                const stats = await collectStatByDistrict(feature.properties.name, activeDataType);
                setSelectedFeature({
                  ...feature,
                  stats
                });
              } else if (activeDataType === "Победитель") {
                setTimeout(() => setSelectedFeature(feature), 0);
              }
            });
          }}


        />
      )}



			{showDistrictLayer && districtData && showPrecinctLayer && (
			  <GeoJSON
				data={districtData}
				style={() => ({
				  color: "#000",
				  weight: 3,
				  fillOpacity: 0,
				  fillColor: "transparent",
				})}
			  />
			)}

      {showPrecinctLayer && uikData && (
        <GeoJSON
          key={`uiks-${year}-${activeElectionLevel}-${activeDataType}-${uikData.features.length}`}
          data={uikData}
          style={(feature) => {
            if (activeDataType === "Победитель") {
              const fillColor = getWinnerColorByAdvantage(
                feature.properties,
                year,
                activeElectionLevel
              );

              let fillOpacity = 1;
              if (year === 2018 && activeElectionLevel === "Президент") {
                const prefix = electionPrefixes["Президент"][2018] || "";
                const winnerKey = Object
                  .entries(feature.properties)
                  .filter(([k]) => k.startsWith(prefix))
                  .sort((a, b) => b[1] - a[1])[0]?.[0] || "";
                const winner = winnerKey.replace(prefix, "");
                const level = legendLevels[winner] || 1;
                const alphas = [0.2, 0.4, 0.6, 0.8];
                fillOpacity = alphas[level - 1] || alphas[0];
              }

              return {
                color: "#000",
                weight: 2,
                fillOpacity,
                fillColor
              };
            }

            return getStyleByDataType(
              feature.properties,
              activeDataType,
              year,
              activeElectionLevel
            );
          }}
          onEachFeature={(feature, layer) => {
            layer.on("click", async () => {
              setSelectedFeature(null);

              if (activeDataType === "Явка" || activeDataType === "Процент испорченных бюллетеней") {
                const stats = await collectStatByUik(feature.properties.uik_num, activeDataType);
                setSelectedFeature({
                  ...feature,
                  stats
                });
              } else if (activeDataType === "Победитель") {
                setTimeout(() => setSelectedFeature(feature), 0);
              }
            });
          }}

        />
      )}







			{selectedFeature && (
			  <GeoJSON
				data={{
				  type: "FeatureCollection",
				  features: [JSON.parse(JSON.stringify(selectedFeature))]
				}}
				style={{
				  color: "#ff7800",
				  weight: 3,
				  fillOpacity: 0.2,
				  dashArray: "5, 5"
				}}
			  />
			)}


			{showDistrictLayer && activeDataType === "Явка" && (
			  <div className="legend-box-horizontal">
				<h4>Явка</h4>
				<div className="legend-vertical">
				  {(activeElectionLevel === "Президент"
					? [
						{ color: "#21814f", label: "более 70%" },
						{ color: "#3a9d66", label: "65–70%" },
						{ color: "#5bbf83", label: "60–65%" },
						{ color: "#a6d9b7", label: "50–60%" },
						{ color: "#e6f4ea", label: "менее 50%" }
					  ]
					: [
						{ color: "#21814f", label: "более 65%" },
						{ color: "#3a9d66", label: "50–65%" },
						{ color: "#5bbf83", label: "35–50%" },
						{ color: "#a6d9b7", label: "20–35%" },
						{ color: "#e6f4ea", label: "менее 20%" }
					  ]
				  ).map((item, idx) => (
					<div key={idx} className="legend-entry">
					  <div className="legend-color-box" style={{ backgroundColor: item.color }}></div>
					  <div className="legend-label">{item.label}</div>
					</div>
				  ))}
				</div>
			  </div>
			)}


			{showDistrictLayer && activeDataType === "Процент испорченных бюллетеней" && (
			  <div className="legend-box-horizontal">
				<h4>Недействительные бюллетени</h4>
				<div className="legend-vertical">
				  {[
					{ color: "#c51b8a", label: "более 2%" },
					{ color: "#ef6cae", label: "1,5–2%" },
					{ color: "#f7b6cf", label: "1–1,5%" },
					{ color: "#fcd2e1", label: "0,5–1%" },
					{ color: "#fde8ef", label: "менее 0,5%" }
				  ].map((item, idx) => (
					<div key={idx} className="legend-entry">
					  <div className="legend-color-box" style={{ backgroundColor: item.color }}></div>
					  <div className="legend-label">{item.label}</div>
					</div>
				  ))}
				</div>
			  </div>
			)}


          </MapContainer>

        </div>
      </div>
    </div>
  );
}

export default App;